<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="flex pt-2">
    <BaseIcon name="HeroXCircleIconOutline" class="mr-2 h-5 w-5 text-xs font-light text-red-500" />
    <span class="text-xs font-light text-foreground">{{ t('pages.review.reviewPage.noResults.facebook') }}</span>
  </div>
</template>
